import React from "react";

import { Route, Switch } from "react-router-dom";

const PublicLayout = ({ children }) => {
  return (
    <React.Fragment>
      <Switch>
        {children.map((route) => {
          return (
            <Route
              path={route?.path}
              component={route?.component}
              render={route?.render}
              key={`${route?.name}`}
            />
          );
        })}
      </Switch>
    </React.Fragment>
  );
};

export default PublicLayout;
